import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { UseFeatureTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/useFeature.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: UseFeatureTrackingInfo) => {
    const event: TypedAnalyticsEvent<UseFeatureTrackingInfo> = {
        event: EventType.UseFeature,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
